export const APP_PATH = process.env['APP_PATH'];
export const API_PATH = process.env['API_PATH'];
export const CDN_PATH = process.env['CDN_PATH'];
export const ENV_NAME = process.env['ENV_NAME'];

export const SCHEDULE_INTERVAL = Number(
  process.env['SCHEDULE_INTERVAL'] || '15',
);

export const appUrl = () => `${APP_PATH}`;
export const notFoundUrl = () => `${appUrl()}404/`;

// anonymous routes
export const userFormUrl = () => `${appUrl()}user/`;
export const loginUrl = () => `${userFormUrl()}login`;
export const registerUrl = () => `${userFormUrl()}register`;
export const forgotPasswordUrl = () => `${userFormUrl()}forgot-password`;
export const authCallbackUrl = () => `${appUrl()}auth/callback`;

// anonymous check routes
export const verifyCheckUrl = () => `${appUrl()}verify/`;
export const verifyCheckWithIdUrl = (code: string) =>
  `${verifyCheckUrl()}${code}`;

export const printECheckUrl = () => `${appUrl()}print-echeck/`;
export const printAnonECheckUrl = (eCheckId: string) =>
  `${printECheckUrl()}${eCheckId}`;

// anonymous info routes
export const disclaimerUrl = () => `${appUrl()}disclaimer/`;
export const helpCenterUrl = () => `https://easyecheck.tawk.help/`;
export const privacyPolicyUrl = () => `${appUrl()}privacy-policy/`;
export const termsAndConditionsUrl = () => `${appUrl()}terms-and-conditions/`;

// user routes
export const tenantListUrl = () => `${appUrl()}`;
export const userPayeeListUrl = () => `${appUrl()}payees/`;
export const resetPasswordUrl = () => `${appUrl()}reset-password/`;
export const resetUserPasswordUrl = (email: string, token: string) =>
  `${resetPasswordUrl()}${email}/${token}`;
export const userPaymentListUrl = () => `${appUrl()}payments/`;
export const userPaymentDetailsUrl = (paymentId: string) =>
  `${appUrl()}payment/${paymentId}/`;

// tenant routes
export const apiSpecUrl = (tenantId: string) =>
  `${tenantUrl(tenantId)}docs`;
export const tenantUrl = (tenantId: string) =>
  `${tenantListUrl()}${tenantId}/`;
export const paymentListUrl = (tenantId: string) =>
  `${tenantUrl(tenantId)}payment/`;

export const userTenantPaymentListUrl = (tenantId: string) =>
  `${tenantUrl(tenantId)}payments/`;

export const tenantDashboardUrl = (tenantId: string) =>
  `${tenantUrl(tenantId)}`;

export const bankListUrl = (tenantId: string) =>
  `${tenantUrl(tenantId)}bank/`;

export const bankCheckListUrl = (tenantId: string, bankId: string) =>
  `${bankListUrl(tenantId)}${bankId}/check`;

export const userPaymentTenantDetailsUrl = (
  tenantId: string,
  paymentId: string,
) => `${tenantUrl(tenantId)}payments/${paymentId}/`;

export const payeeListUrl = (tenantId: string) =>
  `${tenantUrl(tenantId)}payee/`;

export const userTenantPayeeListUrl = (tenantId: string) =>
  `${tenantUrl(tenantId)}payees/`;

export const memberListUrl = (tenantId: string) =>
  `${tenantUrl(tenantId)}members/`;

export const userActivityListUrl = (tenantId: string) =>
  `${tenantUrl(tenantId)}activity/`;

export const settingsUrl = (tenantId: string) =>
  `${tenantUrl(tenantId)}settings/`;

export const auditUrl = (tenantId: string) =>
  `${tenantUrl(tenantId)}audit/`;

export const userProfileUrl = (tenantId?: string | undefined) =>
  tenantId
    ? `${tenantUrl(tenantId)}user/profile/`
    : `${appUrl()}user/profile/`;
